import React from 'react';
import PropTypes from 'prop-types';

import { Header } from './styles/Header';
import { StyledIcon } from './styles/Icon';

export function CollapseHeader({
  children,
  isOpen,
  buttonId,
  contentId,
  handleToggleButton,
}) {
  const buttonIcon = isOpen ? 'minus' : 'plus';

  return (
    <Header
      id={buttonId}
      type="button"
      onClick={handleToggleButton}
      aria-controls={contentId}
      aria-expanded={isOpen}
    >
      {children}

      <StyledIcon
        name={buttonIcon}
        size="small"
        colorVariant="black"
      />
    </Header>
  );
}

CollapseHeader.defaultProps = {
  buttonId: undefined,
  contentId: undefined,
  isOpen: false,
  handleToggleButton: () => {},
};

CollapseHeader.propTypes = {
  buttonId: PropTypes.string,
  children: PropTypes.node.isRequired,
  contentId: PropTypes.string,
  handleToggleButton: PropTypes.func,
  isOpen: PropTypes.bool,
};
